import storesService from './storesService'

export default storesService



// WEBPACK FOOTER //
// ../src/services/storesService/index.js